import { DEFAULT_WAITWHILE_SERVICE_ID } from '../../../config/constants'
import { apiFetch } from '../../../lib/api/client'
import { getEndDate, getStartDate } from '../../../lib/date-helper'
import { useBookingStore } from '../../../store'
import type { Employee } from '../EmployeesList.types'

/**
 * Fetches employees for the given store location using the v4 endpoint.
 * Only locationCode-based lookup is supported — no storeId fallback.
 * Falls back to the environment-specific default service ID when no serviceId
 * has been selected by the user yet.
 */
export async function getEmployees(): Promise<Employee[]> {
  const { env, locationCode, serviceId } = useBookingStore.getState()

  const waitwhileServiceId = serviceId ?? DEFAULT_WAITWHILE_SERVICE_ID[env]

  const params = new URLSearchParams({
    locationCode: locationCode ?? '',
    waitwhileServiceId,
    startDate: getStartDate(),
    endDate: getEndDate(),
  })

  return apiFetch<Employee[]>(`v4/employees?${params.toString()}`)
}
